import { useCallback } from 'react';
import { useApiCall } from './apiHelpers';
import { CommunicationInputData } from './types';

const useGetCommunicationInput = () => {
  const { authFetch, isReady, run, isLoading, error } = useApiCall();

  const fetchCommunicationInput = useCallback(
    async (id: number): Promise<CommunicationInputData | null> => {
      if (!isReady) return null;
      const outcome = await run<CommunicationInputData>(
        () => authFetch(`/communication_inputs/${id}`, { method: 'GET' }),
        'Erreur lors du chargement de la campagne',
      );
      return outcome.ok ? outcome.data : null;
    },
    [authFetch, isReady, run],
  );

  return { fetchCommunicationInput, isReady, isLoading, error };
};

export default useGetCommunicationInput;
